const default_data = false

function reducer( state = default_data, { type, payload } ){
    switch( type ){
        case 'refrescarSitio': {
            return payload
        }
        default:
            return state
    }
}

export default reducer